// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMQrOARUAn5kDzE2iXTTrouwRXd2RGq6w",
  authDomain: "shotam-b276d.firebaseapp.com",
  databaseURL:
    "https://shotam-b276d-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "shotam-b276d",
  storageBucket: "shotam-b276d.firebasestorage.app",
  messagingSenderId: "915460565255",
  appId: "1:915460565255:web:21b41042a3e78d5addbda2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const shotamDatabase = getFirestore(app);
